/* Copyright 2019 The MathWorks, Inc. */
define([
    "./VerifyComponentProperty"
], function (VerifyComponentProperty) {
    return ({
        editOptionMessage: new VerifyComponentProperty({
            type: "string",
            defaultValue: "",
            notInAction: true,
            required: false
        })
    });
});